// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"38c25f4a","467":"b407d600","482":"0922fe7b","599":"4d26f3a0","697":"f10a3b66","746":"81074596","787":"48efc7f5","823":"b5cd42b5"}[chunkId] + ".chunk.js";
};